import definition from './folders.service';

export default {
    name: 'FolderService',
    definition
};



// WEBPACK FOOTER //
// ./app/services/folders/index.js